let ModalAgreement = (function () {
  let prevJobnoticeSn = '';
  let keyData = {
    agreementLetterSn: '',
    agreementItemSnSet: [],
    personalInfoCollectionItemList: [],
    canMoveNextStep: false, //필수선택을 모두 체크하면 true
    jobdaAgreementLetterSn: '',
    jobdaAgreementLetterAgreeYn: false,
    resumeExportAgreementLetterSn: '',
    resumeExportAgreementLetterAgreeYn: false,
  };

  let template = function (
    arr,
    type,
    jobnoticeSn,
    insightAgreementLetterModifyYn,
    jobdaAgreementLetterModifyYn,
  ) {
    let t = [],
      i;
    t.push('<ul class="agreement">');

    if (insightAgreementLetterModifyYn) {
      for (i = 0; i < arr.length; i++) {
        t.push(
          `	<li class="${type ? 'agreementblock' : ''}" data-agreementitemsn="${
            arr[i]['agreementItemSn']
          }" data-agreementItemType="${arr[i]['agreementItemType']}" >`,
        );
        t.push(`		<a class="${type ? 'blocktitle' : 'title'} middle-set">`);
        if (arr[i]['agreementItemType'] !== 'GUIDANCE') {
          t.push(
            `		<label><input name="agreementItemSn" value="${arr[i]['agreementItemSn']}" type="checkbox" /><span class="label"></span></label>`,
          );
        }
        t.push(
          `			<span class="agreementItemName">${
            arr[i].agreementItemName
          }</span><span style="${type ? 'color: #abebdb;' : ''}"> ${
            arr[i]['agreementItemType'] === 'OPTIONAL_AGREEMENT'
              ? '(선택)'
              : arr[i]['agreementItemType'] === 'GUIDANCE'
              ? ''
              : '(필수)'
          }</span>`,
        );
        t.push('		</a>');
        if (!type) {
          t.push('		<div class="contents">');
          t.push(D.unescapeHTML(arr[i].agreementItemContents));
          t.push('		</div>');
        }
        t.push('	</li>');
      }
    }

    if (jobdaAgreementLetterModifyYn) {
      $.ajax({
        type: 'post',
        dataType: 'json',
        beforeSend: Common.loading.show(),
        url: '/app/applicant/getJobdaAgreementLetter',
        async: false,
      })
        .always(Common.loading.countHide)
        .fail(Common.ajaxOnfail)
        .done(function (x, e) {
          keyData.jobdaAgreementLetterSn = x.jobdaAgreementLetterSn;

          /**
           * https://midasitweb-jira.atlassian.net/browse/NMRS-293
           * 정책 변경으로 무조건 체크했다고(true) 가정하고 보내주면 된다.
           * 따라서, 보이지 않게(display: none) 처리하고 무조건 체크된 상태(true)로 처리한다.
           */
          t.push(
            `	<li data-jobdaagreementlettersn="${x['jobdaAgreementLetterSn']}" data-agreementItemType="${x['jobdaAgreementLetterAgreementType']}" style="display: none" >`,
          );
          t.push(`		<a class="title middle-set">`);
          if (x['jobdaAgreementLetterAgreementType'] !== 'GUIDANCE') {
            t.push(
              `		<label><input name="jobdaAgreementLetterSn" value="${x['jobdaAgreementLetterSn']}" type="checkbox" checked/><span class="label"></span></label>`,
            );
          }
          t.push(
            `			<span class="jobdaAgreementLetterName">${
              x.jobdaAgreementLetterName
            }</span><span> ${
              x['jobdaAgreementLetterAgreementType'] === 'OPTIONAL_AGREEMENT'
                ? '(선택)'
                : x['jobdaAgreementLetterAgreementType'] === 'GUIDANCE'
                ? ''
                : '(필수)'
            }</span>`,
          );
          t.push('		</a>');
          t.push('		<div class="contents">');
          t.push(D.unescapeHTML(x.jobdaAgreementLetterContent));
          t.push('		</div>');
          t.push('	</li>');
        });
    }

    $.ajax({
      type: 'POST',
      dataType: 'json',
      beforeSend: Common.loading.show(),
      url: '/app/applicant/getResumeExportAgreementItems',
      data: {
        recruitNoticeSn: jobnoticeSn,
      },
      async: false,
    })
      .always(Common.loading.countHide)
      .fail(Common.ajaxOnfail)
      .done(function (x, e) {
        x.forEach((item) => {
          if (item.useYn) {
            keyData.resumeExportAgreementLetterSn =
              item.systemAgreementLetterSn;
            t.push(
              `	<li class="${
                type ? 'agreementblock' : ''
              }" data-resumeExportAgreementLetterSn="${
                item['systemAgreementLetterSn']
              }" data-agreementItemType="${item['agreementItemType']}">`,
            );
            t.push(`		<a class="${type ? 'blocktitle' : 'title'} middle-set">`);
            if (item['agreementItemType'] !== 'GUIDANCE') {
              t.push(
                `		<label><input name="resumeExportAgreementLetterSn" value="${item['systemAgreementLetterSn']}" type="checkbox"/><span class="label"></span></label>`,
              );
            }
            t.push(
              `			<span class="agreementItemName">${
                item.agreementItemName
              }</span><span style="${type ? 'color: #abebdb;' : ''}"> ${
                item.agreementItemType === 'OPTIONAL_AGREEMENT'
                  ? '(선택)'
                  : item.agreementItemType === 'GUIDANCE'
                  ? ''
                  : '(필수)'
              }</span>`,
            );
            t.push('		</a>');
            t.push('		<div class="contents">');
            t.push(D.unescapeHTML(item.agreementItemContents));
            t.push('		</div>');
            t.push('	</li>');
          }
        });
      });

    t.push('</ul>');
    return t.join('');
  };

  return function (
    jobnoticeSn,
    systemKindCode,
    applicantActionCode,
    jfYn,
    insightAgreementLetterModifyYn,
    jobdaAgreementLetterModifyYn,
    confirmCallback,
    cancelCallback,
    always,
  ) {
    let modalOpt;
    if (!prevJobnoticeSn || prevJobnoticeSn !== jobnoticeSn) {
      $.ajax({
        type: 'post',
        dataType: 'json',
        beforeSend: Common.loading.show(),
        url: '/app/applicant/getPersonalInfoCollection',
        async: false,
        data: {
          jobnoticeSn: jobnoticeSn,
          systemKindCode: systemKindCode,
          applicantActionCode: applicantActionCode,
        },
      })
        .always(Common.loading.countHide)
        .fail(Common.ajaxOnfail)
        .done(function (x, e) {
          keyData.agreementLetterSn = x.agreementLetterSn;
          keyData.personalInfoCollectionItemList =
            x.personalInfoCollectionItemList;
          keyData.agreementItemSnSet = [];
          jfYn = x['jobflexYn'];
        });
      prevJobnoticeSn = jobnoticeSn;
    }

    modalOpt = {
      title: '개인정보 수집ㆍ이용 동의',
      width: '700',
      height: keyData.personalInfoCollectionItemList.length * 50 + 69 + 85,
      scroll: true,
      originCenter: true,
      btnTitle: '확인',
      enabledConfirm: false,
      btnEvent() {
        keyData.canMoveNextStep =
          $('li[data-agreementitemtype="REQUIRED_CONSENT"]')
            .map(function () {
              return $(this).find('input:checkbox').prop('checked');
            })
            .get()
            .indexOf(false) === -1;
        keyData.agreementItemSnSet = $('input[name="agreementItemSn"]:checked')
          .map(function () {
            return parseInt(this.value);
          })
          .get()
          .concat(
            keyData.personalInfoCollectionItemList
              .filter(function (v) {
                return v.agreementItemType === 'GUIDANCE';
              })
              .map(function (v) {
                return v.agreementItemSn;
              }),
          ); //안내일경우에도 보내야함
        keyData.jobdaAgreementLetterAgreeYn = $(
          'input[name="jobdaAgreementLetterSn"]',
        ).prop('checked');

        keyData.resumeExportAgreementLetterAgreeYn = $(
          'input[name="resumeExportAgreementLetterSn"]',
        ).prop('checked');

        if (always) always();

        if (!keyData.canMoveNextStep) {
          Alert('필수항목에 동의를 하셔야 다음단계를 진행하실 수 있습니다.');
          return false;
        }

        if (confirmCallback) confirmCallback();
        return true;
      },
      callback() {
        $('ul.agreement').on('click', 'label', function (e) {
          e.stopPropagation(); //label을 클릭함으로써 li에 버블링 되는 것을 방지
        });

        $(
          'input[name="agreementItemSn"], input[name="resumeExportAgreementLetterSn"]',
        ).on('click', function () {
          if (
            !$(this).prop('checked') &&
            $('#allAgree>input').prop('checked')
          ) {
            $('input[name="allAgree"]').prop('checked', false);
          }
          if (
            $(this).prop('checked') &&
            $(
              'input[name="agreementItemSn"]:checked, input[name="resumeExportAgreementLetterSn"]:checked',
            ).length ===
              $(
                'input[name="agreementItemSn"], input[name="resumeExportAgreementLetterSn"]',
              ).length
          ) {
            $('input[name="allAgree"]').prop('checked', true);
          }
        });

        $('ul.agreement').on('click', 'li', function (e) {
          if ($(this).hasClass('active')) {
            $(this).find('.contents').mCustomScrollbar('destroy');
          } else {
            $(this)
              .find('.contents')
              .mCustomScrollbar({
                snapAmount: 70,
                keyboard: { scrollAmount: 70 },
                mouseWheel: { deltaFactor: 70 },
                scrollInertia: 400,
                theme: 'dark-2',
              });
          }
          $(this).toggleClass('active');
          $(this).find('.contents').slideToggle('0.2s');
        });

        //    jobflex 채용박람회 모두동의
        $('#modal > div.modal').append(
          '<label id="allAgree"><input name="allAgree" value="51" type="checkbox"><span class="label"></span>전체동의</label>',
        );

        $(document).on('click', '#allAgree', function () {
          if ($(this).find('input').prop('checked')) {
            $('input[name="agreementItemSn"]').each(function () {
              $(this).prop('checked', true);
            });
            if (jobdaAgreementLetterModifyYn) {
              $('input[name="jobdaAgreementLetterSn"]').prop('checked', true);
            }
            $('input[name="resumeExportAgreementLetterSn"]').each(function () {
              $(this).prop('checked', true);
            });
          } else {
            $('input[name="agreementItemSn"]').each(function () {
              $(this).prop('checked', false);
            });
            if (jobdaAgreementLetterModifyYn) {
              $('input[name="jobdaAgreementLetterSn"]').prop('checked', false);
            }
            $('input[name="resumeExportAgreementLetterSn"]').each(function () {
              $(this).prop('checked', false);
            });
          }
        });

        //    jobflex 미리보기
        $(document).on('click', 'li.agreementblock', function () {
          window.open(
            `/app/applicant/agreement/custom/${$(this).data(
              'agreementitemsn',
            )}`,
            '개인정보 제공 수집',
            'width=900,height=600',
          );
        });
      },
      cancelEvent() {
        // 최종 제출 페이지, 지원서 수정 페이지, 마이페이지 일 때는 jobda 동의서만 변경된 경우. 선택사항이기 때문에 취소 누르면 다음으로 진행해야 한다.
        if (cancelCallback) {
          cancelCallback();
        }

        return true;
      },
      content: template(
        keyData.personalInfoCollectionItemList,
        jfYn,
        jobnoticeSn,
        insightAgreementLetterModifyYn,
        jobdaAgreementLetterModifyYn,
      ),
    };
    Common.modal(modalOpt);

    return keyData;
  };
})();
